import _ from "lodash"

let tables = {
    applicationsSignedOff: {
        columns: [
            { field: 'created_at', label: 'Date Created', sortable: true },
            { field: 'applicant_id', label: 'Contact', sortable: true },
            { field: 'type', label: 'Type', sortable: true },
            { field: 'numeric_type', label: 'Name', sortable: true },
            { field: 'project_name', label: 'Project Name', sortable: true },
            { field: 'project_address', label: 'Project Address', sortable: true },
            { field: 'job_number', label: 'Job Number', sortable: true },
            { field: 'project_manager_id', label: 'Project Manager', sortable: true }
        ],

        default: [
            'created_at', 'applicant_id', 'type', 'numeric_type', 'job_number', 'project_address', 'project_name', 'project_manager_id'
        ]
    },

    applicationsUnderReview: {
        columns: [
            { field: 'created_at', label: 'Date Created', sortable: true },
            { field: 'applicant_id', label: 'Contact', sortable: true },
            { field: 'type', label: 'Type', sortable: true },
            { field: 'numeric_type', label: 'Name', sortable: true },
            { field: 'project_name', label: 'Project Name', sortable: true },
            { field: 'project_address', label: 'Project Address', sortable: true },
            { field: 'job_number', label: 'Job Number', sortable: true },
            { field: 'project_manager_id', label: 'Project Manager', sortable: true }
        ],

        default: [
            'created_at', 'applicant_id', 'type', 'numeric_type', 'job_number', 'project_address', 'project_name', 'project_manager_id'
        ]
    },

    changelogsIndex: {
        columns: [
            { field: 'actor_id', label: 'Actor', sortable: true },
            { field: 'action', label: 'Action', sortable: true },
            { field: 'meta', label: 'Meta', sortable: true },
            { field: 'reference_id', label: 'Reference', sortable: true },
            { field: 'reference_type', label: 'Reference Type', sortable: false },
            // {field: 'actions', label: 'Actions', sortable: false},
            { field: 'created_at', label: 'Created At', sortable: true },
        ],
        default: ['reference_type', 'reference_id', 'action', 'actions']
    },

    changeOrders: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'number', label: 'Number', sortable: true },
            { field: 'floor_number', label: 'Floor Number', sortable: true },
            { field: 'company', label: 'Company', sortable: true },
            { field: 'contact', label: 'Contact', sortable: true },
            { field: 'approval_deadline', label: 'Approval Deadline', sortable: true },
            { field: 'notes', label: 'Description', sortable: true },
            { field: 'deposit_percent', label: 'Deposit %', sortable: true },
            { field: 'pay_in_full', label: 'Pay in Full', sortable: true },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'status_updated_at', label: 'Status Updated At', sortable: true },
            { field: 'sent_at', label: 'Sent At', sortable: true },
            { field: 'created_by', label: 'Created By', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
        ],
        default: ['number', 'status', 'status_updated_at', 'notes', 'created_by', 'created_at', 'actions'],
    },

    changeOrdersStats: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'number', label: 'Number', sortable: true },
            { field: 'floor_number', label: 'Floor Number', sortable: true },
            { field: 'company', label: 'Company', sortable: true },
            { field: 'contact', label: 'Contact', sortable: true },
            { field: 'approval_deadline', label: 'Approval Deadline', sortable: true },
            { field: 'notes', label: 'Description', sortable: true },
            { field: 'total_price', label: 'Total', sortable: true },
            { field: 'deposit_percent', label: 'Deposit %', sortable: true },
            { field: 'pay_in_full', label: 'Pay in Full', sortable: true },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'status_updated_at', label: 'Status Updated At', sortable: true },
            { field: 'sent_at', label: 'Sent At', sortable: true },
            { field: 'created_by', label: 'Created By', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
        ],
        default: ['number', 'status', 'status_updated_at', 'notes', 'total_price', 'created_by', 'created_at', 'actions'],
    },

    clocklogs: {
        columns: [
            { field: 'user_name', label: 'Employee', sortable: true },
            { field: 'date', label: 'Date', sortable: true },
            { field: 'punches', label: 'Punches', sortable: true },
            { field: 'total_hours', label: 'Total hours', sortable: true },
            { field: 'status', label: 'status', sortable: false },
            { field: 'browser', label: 'Browser', sortable: false },
            { field: 'device', label: 'Device', sortable: false },
            { field: 'platform', label: 'Platform', sortable: false },
        ],
        default: [
            'user_name',
            'status',
            'date',
            'punches',
            'total_hours',
            'device',
        ],
    },

    companiesIndex: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'email', label: 'Email', sortable: true },
            { field: 'name', label: 'Name', sortable: true },
            { field: 'address', label: 'Address', sortable: true },
            { field: 'city', label: 'City', sortable: true },
            { field: 'state', label: 'State', sortable: true },
            { field: 'zip', label: 'Zip', sortable: true },
            { field: 'phone', label: 'Phone', sortable: true },
            { field: 'fax', label: 'Fax', sortable: true },
            { field: 'task_based', label: 'Task Based', sortable: true },
            { field: 'ibm_number', label: 'IBM Number', sortable: true },
            { field: 'ibm_exp_date', label: 'IBM Exp. Date', sortable: true },
            { field: 'tax_id', label: 'Tax Id', sortable: true },
            { field: 'hic_license', label: 'HIC License', sortable: true },
            { field: 'dob_tracking', label: 'DOB Tracking', sortable: true },
            { field: 'dob_tracking_exp_date', label: 'DOB Tracking Exp. Date', sortable: false },
            { field: 'special_inspection_agency', label: 'Special Inspection Agency', sortable: false },
            { field: 'notes', label: 'Notes', sortable: false },
            { field: 'actions', label: 'Actions', sortable: false },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
            { field: 'lead_owner', label: 'Lead Owner', sortable: false }
        ],
        default: ['name', 'address', 'city', 'state', 'zip', 'phone', 'actions']
    },

    contactsIndex: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'full_name', label: 'Full Name', sortable: true },
            { field: 'first_name', label: 'First Name', sortable: true },
            { field: 'last_name', label: 'Last Name', sortable: true },
            { field: 'telephone', label: 'Telephone', sortable: true },
            { field: 'mobile', label: 'Mobile', sortable: true },
            { field: 'email', label: 'Email', sortable: true },
            { field: 'fax', label: 'Fax', sortable: true },
            { field: 'title', label: 'Title', sortable: true },
            { field: 'address_1', label: 'Address', sortable: true },
            { field: 'zip', label: 'Zip', sortable: true },
            { field: 'company_id', label: 'Company', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
            { field: 'lead_owner', label: 'Lead Owner', sortable: false },
            { field: 'tax_id', label: 'Tax Id', sortable: false },
            { field: 'formatted_licenses', label: 'License Number', sortable: false },
        ],
        default: ['first_name', 'last_name', 'telephone', 'mobile', 'email', 'city', 'actions'],
    },

    mergeCompanies: {
        columns: [
                    { field: 'name', label: 'name', sortable: false },
                    { field: 'address', label: 'address', sortable: false },
                    { field: 'city', label: 'city', sortable: false },
                    { field: 'state', label: 'state', sortable: false },
                    { field: 'zip', label: 'zip', sortable: false },
                    { field: 'phone', label: 'phone', sortable: false },
                    { field: 'fax', label: 'fax', sortable: false },
                    { field: 'email', label: 'email', sortable: false },
                    { field: 'notes', label: 'notes', sortable: false },
                    { field: 'lead_owner', label: 'lead owner', sortable: false },
                    { field: 'ibm_number', label: 'ibm number', sortable: false },
                    { field: 'ibm_exp_date', label: 'ibm exp date', sortable: false },
                    { field: 'tax_id', label: 'tax_id', sortable: false },
                    { field: 'hic_license', label: 'hic license', sortable: false },
                    { field: 'dob_tracking', label: 'dob tracking', sortable: false },
                    { field: 'dob_tracking_exp_date', label: 'dob tracking exp date', sortable: false },
                    { field: 'special_inspection_agency', label: 'special inspection agency', sortable: false },
        ],
        default: ['name', 'address', 'city', 'state', 'zip', 'phone', 'fax', 'email', 'notes', 'lead_owner', 'ibm_number', 'ibm_exp_date', 'tax_id', 'hic_license', 'dob_tracking', 'dob_tracking_exp_date', 'special_inspection_agency', 'task_based'],
    },

    mergeContacts: {
        columns: [
                { field: 'first_name', label: 'first name', sortable: false },
                { field: 'last_name', label: 'last name', sortable: false },
                { field: 'email', label: 'email', sortable: false },
                { field: 'telephone', label: 'telephone', sortable: false },
                { field: 'mobile', label: 'mobile', sortable: false },
                { field: 'company_id', label: 'company_id', sortable: false },
                { field: 'lead_owner', label: 'lead owner', sortable: false },
                { field: 'fax', label: 'fax', sortable: false },
                { field: 'title', label: 'title', sortable: false },
                { field: 'address_1', label: 'address 1', sortable: false },
                { field: 'address_2', label: 'address 2', sortable: false },
                { field: 'city', label: 'city', sortable: false },
                { field: 'state', label: 'state', sortable: false },
                { field: 'zip', label: 'zip', sortable: false },
                { field: 'tax_id', label: 'tax id', sortable: false },
        ],
        default: ['first_name', 'last_name', 'email', 'telephone', 'mobile', 'company_id', 'lead_owner', 'fax', 'title', 'address_1', 'address_2', 'city', 'state', 'zip', 'tax_id' ],
    },

    notesHistory: {
        columns: [
            { field: 'value', label: 'Notes', sortable: true },
            { field: 'user', label: 'User', sortable: true },
            { field: 'created_at', label: 'Created at', sortable: true },
        ],
        default: ['value', 'created_at'],
    },

    openExpenses: {
        columns: [
            { field: 'project_id', label: 'Project#', sortable: true },
            { field: 'project_address', label: 'Address', sortable: true },
            { field: 'project_name', label: 'Project Name', sortable: true },
            { field: 'service_title', label: 'Service', sortable: true },
            { field: 'final_price', label: 'Amount', sortable: true },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'type', label: 'Type', sortable: true },
            { field: 'assigned_to', label: 'Assigned To', sortable: true },
            { field: 'description', label: 'Notation', sortable: true },
            { field: 'reimbursable', label: 'Reimbursable', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
            { field: 'created_by', label: 'Created by', sortable: true },
        ],
        default: [
            'project_id',
            'project_name',
            'service_title',
            'final_price',
            'description',
            'status',
            'assigned_to',
            'created_at',
            'created_by',
        ],
    },

    productionReport: {
        columns: [
            { field: 'service_title', label: 'Services List', sortable: true },
            { field: 'company_name', label: 'Client', sortable: true },
            { field: 'project_number', label: 'Project #', sortable: true },
            { field: 'project_contract', label: 'Project Contract', sortable: true },
            { field: 'pm', label: 'PM', sortable: true },
            { field: 'project_address', label: 'Address', sortable: true },
            { field: 'project_borough', label: 'Borough', sortable: true },
            { field: 'salesperson', label: 'Salesperson', sortable: true },
            { field: 'proposal_date', label: 'Proposal Date', sortable: true },
            { field: 'converted_date', label: 'Converted Date', sortable: true },
            { field: 'team', label: 'Team', sortable: true },
            { field: 'work_types', label: 'Sub Services', sortable: true },
            { field: 'service_price', label: 'Service $', sortable: true },
            { field: 'billed_price', label: 'Total Cost', sortable: true },
            { field: 'billed_time', label: 'Total Time', sortable: true },
            { field: 'reimbursable', label: 'Reimb', sortable: true },
            { field: 'week_ending', label: 'Week Ending', sortable: true },
            { field: 'notes', label: 'Notes', sortable: true },
            { field: 'notes_created_by', label: 'Notes Creator', sortable: true },
            { field: 'notes_created_at', label: 'Notes Created At', sortable: true },
            { field: 'assigned_to', label: 'Assigned To', sortable: true },
        ],

        default: [
            'service_title', 'company_name', 'project_number', 'project_contract', 'project_address',
            'project_borough', 'salesperson', 'assigned_to', 'proposal_date', 'converted_date', 'team', 'work_types', 'service_price',
            'billed_price', 'billed_time', 'reimbursable', 'week_ending', 'notes', 'notes_created_by', 'notes_created_at', 'pm'
        ],
    },

    projectServices: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'type', label: 'Type', sortable: true },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'assigned_to', label: 'Assigned To', sortable: true },
            { field: 'title', label: 'Item', sortable: true },
            { field: 'work_types', label: 'Sub services', sortable: false },
            { field: 'price', label: 'Price', sortable: true },
            { field: 'estimated_bill_date', label: 'Estimated Bill Date', sortable: true },
            { field: 'notes_history', label: 'Notes', sortable: true },
            { field: 'reimbursable', label: 'Reimbursable', sortable: true },
            { field: 'billed_by', label: 'Billed By', sortable: true },
            { field: 'billed_at', label: 'Billed At', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
        ],

        default: ['type', 'status', 'assigned_to', 'title', 'work_types', 'price', 'estimated_bill_date', 'billed_at', 'created_at', 'actions']
    },

    projectsIndex: {
        columns: [
            {field: 'last_editor_id', label: 'Last Editor', sortable: true},
            {field: 'name', label: 'Name', sortable: true},
            {field: 'completion_date', label: 'Est. Completion Date', sortable: true},
            {field: 'id', label: 'Project #', sortable: true},
            {field: 'bbl', label: 'BBL', sortable: true},
            {field: 'address', label: 'Address', sortable: true},
            {field: 'borough', label: 'Borough', sortable: true},
            {field: 'status', label: 'Status', sortable: true},
            {field: 'notable', label: 'Notable', sortable: true },
            {field: 'project_type', label: 'Type of Project', sortable: true },
            {field: 'assigned_to', label: 'Project Manager', sortable: true},
            {field: 'company_id', label: 'Company', sortable: true},
            {field: 'senior_pm_id', label: 'Senior PM', sortable: true},
            {field: 'latest_note', label: 'Latest Note', sortable: true},
            {field: 'latest_task', label: 'Latest Activity', sortable: false},
            {field: 'created_at', label: 'Created At', sortable: true},
            {field: 'updated_at', label: 'Updated At', sortable: true},
            {field: 'actions', label: 'Actions', sortable: false},
        ],

        default: ['name', 'completion_date', 'id', 'bbl', 'address', 'bourough', 'status', 'assigned_to', 'latest_note', 'actions']
    },

    proposalConversionRates: {
        columns: [
            { field: 'date', label: 'Date', sortable: true },
            { field: 'proposals_count', label: 'Proposals Count', sortable: true },
            { field: 'converted_count', label: 'Converted Count', sortable: true },
            { field: 'conversion_rate', label: 'Conversion Rate', sortable: true },
            { field: 'rolling_proposals_avg_6mo', label: 'Rolling Proposals avg/6mo', sortable: true },
            { field: 'rolling_conversion_rate_6mo', label: 'Rolling Conversion rate/6mo', sortable: true },
            { field: 'proposals_total_value', label: 'Proposals Total Value', sortable: true },
            { field: 'converted_value', label: 'Converted Value', sortable: true },
            { field: 'converted_value_avg', label: 'Converted Value Avg', sortable: true },
            { field: 'change_order_value', label: 'Converted Change Orders', sortable: true },
            { field: 'total_value', label: 'Converted total', sortable: true },
            { field: 'fte', label: 'FTE', sortable: true },
        ],

        default: [
            'date', 'proposals_count', 'converted_count', 'conversion_rate', 'rolling_proposals_avg_6mo',
            'rolling_conversion_rate_6mo', 'proposals_total_value', 'converted_value', 'converted_value_avg', 'change_order_value', 'total_value', 'fte'
        ],
    },

    proposalsIndex: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'project_id', label: 'Project', sortable: true },
            { field: 'number', label: 'Number', sortable: true },
            { field: 'type', label: 'Type', sortable: true },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'notable', label: 'Notable', sortable: true },
            { field: 'project_type', label: 'Type of Project', sortable: true },
            { field: 'sent_at', label: 'Sent At', sortable: true },
            { field: 'company_id', label: 'Company', sortable: true },
            { field: 'contact_id', label: 'Contact', sortable: true },
            { field: 'borough', label: 'Borough', sortable: true },
            { field: 'street', label: 'Street', sortable: true },
            { field: 'building', label: 'Building', sortable: true },
            { field: 'floor_number', label: 'Floor Number', sortable: true },
            { field: 'deposit_percent', label: 'Deposit Percent', sortable: true },
            { field: 'pay_in_full', label: 'Pay In Full', sortable: true },
            { field: 'billed_to_company', label: 'Billed To Company', sortable: true },
            { field: 'billed_to_contact', label: 'Billed To Contact', sortable: true },
            { field: 'sales_id', label: 'Sales Id', sortable: false },
            { field: 'permit_type', label: 'Permit Type', sortable: false },
            { field: 'work_type_id', label: 'Work Type', sortable: false },
            { field: 'terms_and_conditions', label: 'Terms And Conditions', sortable: false },
            { field: 'created_by', label: 'Creator', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
            { field: 'date_created', label: 'Date Created', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
        ],

        default: ['number', 'company_id', 'address', 'borough', 'status', 'created_by', 'created_at', 'project', 'actions']
    },

    remindersIndex: {
        columns: [
            { field: 'description', label: 'Description', sortable: true },
            {field: 'project', label: 'Project', sortable: true},
            { field: 'reference_type', label: 'Reference', sortable: true },
            { field: 'snoozed', label: 'Status', sortable: true },
            { field: 'user_id', label: 'User', sortable: true },
            { field: 'remind_at', label: 'Remind At', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false }
        ],

        default: ['description', 'project', 'reference_type', 'snoozed', 'user_id', 'remind_at', 'actions']
    },

    serviceLevel: {
        columns: [
            { field: 'amount', label: 'Amount', sortable: true },
            { field: 'avgTimelog', label: 'Avg Timelog', sortable: true},
            { field: 'days', label: 'Total Days', sortable: true },
            { field: 'daysAvg', label: 'Avg Days', sortable: true },
            { field: 'qty', label: 'Qty', sortable: true },
            { field: 'title', label: 'Service', sortable: true },
        ],
        default: [
            'title',
            'daysAvg',
            'avgTimelog',
            'days',
            'qty',
            'amount',
        ],
    },

    serviceLevelDetails: {
        columns: [
            { field: 'amount', label: 'Amount', sortable: true },
            { field: 'billed_at', label: 'Billed At', sortable: true },
            { field: 'borough', label: 'Borough', sortable: true },
            { field: 'client_name', label: 'Client', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'days', label: 'Total Days', sortable: true },
            { field: 'estimated_bill_date', label: 'Estimated Date', sortable: true },
            { field: 'project_address', label: 'Address', sortable: true },
            { field: 'project_id', label: 'Project#', sortable: true },
            { field: 'project_manager', label: 'Project Manager', sortable: true },
            { field: 'project_name', label: 'Project Name', sortable: true },
            { field: 'timelog', label: 'Timelog', sortable: true },
            { field: 'title', label: 'Item', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
        ],
        default: [
            'project_manager',
            'client_name',
            'borough',
            'days',
            'timelog',
            'created_at',
            'billed_at',
            'project_id',
            'project_name',
            'project_address',
            'amount',
            'title',
        ],
    },

    servicesIndex: {
        columns: [
            { field: 'is_initial', label: 'Is Initial', sortable: true },
            { field: 'is_optional', label: 'Is Optional', sortable: true },
            { field: 'title', label: 'Title', sortable: true },
            { field: 'description', label: 'Description', sortable: true },
            { field: 'price', label: 'Price', sortable: true },
            { field: 'subservice_price', label: 'Subservice Price', sortable: true },
            { field: 'is_active', label: 'Is Active', sortable: true },
            { field: 'reimbursable', label: 'Reimbursable', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
        ],
        default: ['title', 'price', 'is_initial', 'is_optional', 'subservice_price', 'description', 'actions'],
    },

    servicesPerUser: {
        columns: [],
        default: ['service_id_152__service_title_Project Coordination', 'service_id_153__service_title_Form Preparation', 'service_id_1__service_title_Alteration Type 2 D14 Approval', 'service_id_2__service_title_Alteration Type 2 Non D14 Approval', 'service_id_8__service_title_Alteration Type 1 Approval', 'service_id_3__service_title_Work Permit', 'service_id_7__service_title_Letter of Completion', 'service_id_154__service_title_Letter of Completion for DOB Now: Build Application', 'service_id_9__service_title_Certificate of Occupancy', 'service_id_4__service_title_Landmarks Preservation Commission Approval', 'service_id_12__service_title_PAA - Post Approval Amendment', 'service_id_14__service_title_Reinstatement'],
    },

    servicesUpcoming: {
        columns: [
            { field: 'project_id', label: 'Project#', sortable: true },
            { field: 'project_address', label: 'Address', sortable: true },
            { field: 'project_name', label: 'Project Name', sortable: true },
            { field: 'service_title', label: 'Service', sortable: true },
            { field: 'estimated_bill_date', label: 'Estimated Date', sortable: true },
            { field: 'final_price', label: 'Amount', sortable: true },
            { field: 'notes_history', label: 'Notes', sortable: true },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'type', label: 'Type', sortable: true },
            { field: 'assigned_to', label: 'Assigned To', sortable: true },
            { field: 'title', label: 'Item', sortable: true },
            { field: 'work_types', label: 'Sub services', sortable: false },
            { field: 'description', label: 'Notation', sortable: true },
            { field: 'reimbursable', label: 'Reimbursable', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
        ],
        default: [
            'project_id',
            'project_name',
            'project_address',
            'service_title',
            'estimated_bill_date',
            'final_price',
            'notes_history',
            'status',
        ],
    },

    servicesUpcomingIndex: {},

    tasksByLocation: {
        columns: [
            {field: 'last_editor_id', label: 'Last Editor', sortable: true},
            {field: 'title', label: 'Title', sortable: true},
            {field: 'description', label: 'Description', sortable: true},
            {field: 'location', label: 'Location', sortable: false},
            {field: 'status', label: 'Status', sortable: true},
            {field: 'is_external', label: 'External', sortable: true},
            {field: 'is_milestone', label: 'Is Milestone', sortable: true},
            {field: 'is_package_log', label: 'Is Package Log', sortable: true},
            {field: 'assignee_id', label: 'Assigned To', sortable: true},
            {field: 'date_created', label: 'Date Created', sortable: true},
            {field: 'due_date', label: 'Due Date', sortable: true},
            {field: 'date_completed', label: 'Date Completed', sortable: true},
            {field: 'date_requested', label: 'Date Requested', sortable: true},
            {field: 'date_sent', label: 'Date Sent', sortable: true},
            {field: 'date_received', label: 'Date Received', sortable: true},
            {field: 'creator_id', label: 'Creator', sortable: true},
            {field: 'project_id', label: 'Project', sortable: true},
            {field: 'contact_id', label: 'Contact', sortable: true},
            {field: 'category_id', label: 'Category', sortable: true},
            {field: 'latest_note', label: 'Latest Note', sortable: true},
            {field: 'application_id', label: 'Related To', sortable: true},
            {field: 'created_at', label: 'Created At', sortable: true},
            {field: 'updated_at', label: 'Updated At', sortable: true},
            {field: 'actions', label: 'Actions', sortable: false},
        ],

        default: ['title', 'description', 'status', 'assignee_id', 'location', 'latest_note', 'actions']
    },

    tasksIndex: {
        columns: [
            { field: 'last_editor_id', label: 'Last Editor', sortable: true },
            { field: 'title', label: 'Title', sortable: true },
            { field: 'description', label: 'Description', sortable: true },
            { field: 'location', label: 'Location', sortable: false },
            { field: 'status', label: 'Status', sortable: true },
            { field: 'is_external', label: 'External', sortable: true },
            { field: 'is_milestone', label: 'Is Milestone', sortable: true },
            { field: 'is_package_log', label: 'Is Package Log', sortable: true },
            { field: 'assignee_id', label: 'Assigned To', sortable: true },
            { field: 'date_created', label: 'Date Created', sortable: true },
            { field: 'due_date', label: 'Due Date', sortable: true },
            { field: 'date_completed', label: 'Date Completed', sortable: true },
            { field: 'date_requested', label: 'Date Requested', sortable: true },
            { field: 'date_sent', label: 'Date Sent', sortable: true },
            { field: 'date_received', label: 'Date Received', sortable: true },
            { field: 'creator_id', label: 'Creator', sortable: true },
            { field: 'project_id', label: 'Project', sortable: true },
            { field: 'project_service_id', label: 'Service', sortable: true },
            { field: 'contact_id', label: 'Contact', sortable: true },
            { field: 'category_id', label: 'Category', sortable: true },
            { field: 'latest_note', label: 'Latest Note', sortable: true },
            { field: 'application_id', label: 'Related To', sortable: true },
            { field: 'created_at', label: 'Created At', sortable: true },
            { field: 'updated_at', label: 'Updated At', sortable: true },
            { field: 'actions', label: 'Actions', sortable: false },
        ],

        default: ['title', 'description', 'status', 'project_id', 'project_service_id', 'creator_id', 'assignee_id', 'latest_note', 'actions']
    },

    timelogsIndex: {
        columns: [
            {field: 'user_id', label: 'User', sortable: true},
            {field: 'date', label: 'Date', sortable: true},
            {field: 'time', label: 'Time', sortable: true},
            {field: 'cost', label: 'Cost', sortable: true},
            {field: 'hourly_rate', label: 'Hourly Rate', sortable: true},
            {field: 'client', label: 'Client', sortable: true},
            {field: 'focus', label: 'Focus', sortable: true},
            {field: 'note', label: 'Note', sortable: true},
            {field: 'project_id', label: 'Project', sortable: true},
            {field: 'activity', label: 'Activity', sortable: false},
            {field: 'activity_type', label: 'Reference Type', sortable: true},
            {field: 'actions', label: 'Actions', sortable: false},
            {field: 'created_at', label: 'Created At', sortable: true},
            {field: 'updated_at', label: 'Updated At', sortable: true},
            {field: 'last_editor_id', label: 'Last Editor', sortable: true},
        ],
        default: ['user_id', 'project_id', 'date', 'time', 'note', 'activity_id', 'created_at', 'actions']
    },

    usersIndex: {
        columns: [
            {field: 'last_editor_id', label: 'Last Editor', sortable: true},
            {field: 'email', label: 'Email', sortable: true},
            {field: 'full_name', label: 'Full Name', sortable: true},
            {field: 'first_name', label: 'First Name', sortable: true},
            {field: 'last_name', label: 'Last Name', sortable: true},
            {field: 'avatar_url', label: 'Avatar Url', sortable: true},
            {field: 'status', label: 'Status', sortable: true},
            {field: 'mobile', label: 'Mobile', sortable: true},
            {field: 'phone_extension', label: 'Phone Extension', sortable: true},
            {field: 'carrier', label: 'Carrier', sortable: true},
            {field: 'title', label: 'Title', sortable: true},
            {field: 'role', label: 'Role', sortable: true},
            {field: 'blocked', label: 'Blocked', sortable: true},
            {field: 'actions', label: 'Actions', sortable: false},
            {field: 'created_at', label: 'Created At', sortable: true},
            {field: 'updated_at', label: 'Updated At', sortable: true},
        ],
        default: ['first_name', 'last_name', 'email', 'actions'],
    },

    rolesIndex: {
        columns: [
            {field: 'name', label: 'Name', sortable: true},
            {field: 'description', label: 'Description', sortable: true},
            {field: 'last_editor_id', label: 'Last Editor', sortable: true},
            {field: 'created_at', label: 'Created At', sortable: true},
            {field: 'updated_at', label: 'Updated At', sortable: true},
        ],
        default: ['name', 'description', 'last_editor_id', 'updated_at'],
    },
}

tables.servicesUpcomingIndex = tables.servicesUpcoming

let projectContacts = _.cloneDeep(tables.contactsIndex)
projectContacts.columns.unshift({field: 'role', label: 'Role', sortable: false})
projectContacts.default = ['first_name', 'last_name', 'telephone', 'email', 'role']

tables.projectContacts = projectContacts

tables.contactProjects = _.cloneDeep(tables.projectsIndex)
tables.contactProposals = _.cloneDeep(tables.proposalsIndex)
tables.contactTasks = _.cloneDeep(tables.tasksIndex)

tables.contactProjects.default = ['name', 'completion_date', 'borough', 'status', 'assigned_to']
tables.contactProposals.default = ['number', 'created_at', 'address', 'project', 'converted', 'status', 'actions']
tables.contactTasks.default = ['title', 'description', 'created_at']

export const tableSettings = state => state.tableSettings.items

export const tableColumnsBySlug = (state) => slug => {
    let table = tables[_.camelCase(slug)]

    if (!table) return []

    let allColumns = table.columns,
        userSettings = _.find(tableSettings(state), {slug}),
        userColumns = userSettings ? userSettings.columns : [],
        columns = userColumns.length ? userColumns : table.default

    return _.reduce(columns, (res, columnName) => {
        let column = _.find(allColumns, {field: columnName})
        if (column) res.push(column)
        return res
    }, [])
}

export const allTableColumnsBySlug = () => slug => tables[_.camelCase(slug)].columns

export const tableBySlug = () => slug => tables[_.camelCase(slug)]

export const tableSettingsBySlug = state => slug => {
    return _.find(tableSettings(state), {slug})
}
